<template>
  <div class="container">
    <BreadcrumbGroup v-if="!isAuWallet()" :items="breadcrumbItems" />

    <HeadingOne class="-margin-md"
      >au PAY 残高にチャージ（お借り入れ）</HeadingOne
    >

    <ErrorsAlert :errors="errors"></ErrorsAlert>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="1" type="mb"></MainWizard>
    </WizardGroup>

    <section>
      <p class="_mb-0">
        内容をご確認のうえ、よろしければ「お申し込み」を押してください。
      </p>

      <TableBox class="_mb-sm-40 _mb-md-60 _mt-30">
        <TableBody>
          <TableRow>
            <TableHeader class="-requires"> チャージ予定日 </TableHeader>
            <TableData class="-pctextright">
              お手続き完了後、すぐにご利用いただけます。
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader> お借り入れ金額 </TableHeader>
            <TableData class="-pctextright">
              {{ numberToCurrency(userData.amount * 10000) }}
            </TableData>
          </TableRow>
        </TableBody>
      </TableBox>

      <small
        >※以下の場合はご利用いただけませんので、他のお借り入れ方法にてご利用ください。</small
      >

      <ListGroup class="-normal _mt-10">
        <ListItem class="-normal"
          >au PAY
          プリペイドカードをお持ちでないまたは、ご登録名義が異なる場合</ListItem
        >
        <ListItem class="-normal"
          >au PAY 残高のチャージ上限額を超える場合</ListItem
        >
        <ListItem class="-normal">システムメンテナンス時間帯など</ListItem>
      </ListGroup>

      <template v-if="!isAuWallet()">
        <HeadingFour class="_mt-20 _mb-10">その他のお借り入れ方法</HeadingFour>
        <BtnText router-name="mb011" class="-next -ib _mb-md-10 _mb-sm-15"
          >ご登録口座へのお振込み</BtnText
        ><br />
        <BtnText router-name="sv025" target="_blank" class="-next -ib"
          >セブン銀行スマホＡＴＭ</BtnText
        >
      </template>

      <form novalidate @submit.prevent="submitDepositIntoPrepaid">
        <BtngroupSingle class="-margin-lg _mb-sm-40">
          <BtnMain class="-main" @click.prevent="submitDepositIntoPrepaid">
            お申し込み
          </BtnMain>
        </BtngroupSingle>
      </form>

      <BtngroupSingle class="-margin-lg">
        <BtnBack class="-back -md" router-name="mb012"> 修正する </BtnBack>
      </BtngroupSingle>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import {
  getUserDataForMemberLambdaInvoke,
  submitDepositIntoPrepaidLambdaInvoke,
} from "@/utils/LambdaHelper";
import { isAuWallet } from "@/utils/UserAgent";
import { setMeta } from "@/utils/Meta";
import { numberToCurrency } from "@/utils/Filter";
import { goToErrorPage, scrollTop } from "@/utils/Other";

import HeadingOne from "@/components/heading/HeadingOne";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import BtnText from "@/components/button/BtnText";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import HeadingFour from "@/components/heading/HeadingFour";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb014",
  components: {
    HeadingFour,
    ErrorsAlert,
    BtnBack,
    BtnMain,
    BtngroupSingle,
    BtnText,
    ListItem,
    ListGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    MainWizard,
    WizardGroup,
    HeadingOne,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "au PAY 残高にチャージ（お借り入れ）｜お借り入れ",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト",
    });

    return {
      numberToCurrency,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "au PAY 残高にチャージ（お借り入れ）",
          active: true,
        },
      ],
      errors: {},
      isDisabled: false,
      userData: {
        amount: "",
      },
    };
  },
  mounted() {
    try {
      getUserDataForMemberLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitDepositIntoPrepaid: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        initCredentials()
          .then(() => {
            submitDepositIntoPrepaidLambdaInvoke()
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  this.$router.push({ name: "tem008" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    isAuWallet: function () {
      return isAuWallet();
    },
  },
};
</script>

<style scoped></style>
